import { TAG_TYPE } from "@utils/constants";

function getLimitText(text, userTagList = null, limit = 300, lineLimit = 3) {
  if (!text) return { text: "", flag: null };

  let array = text.split("\n");
  let limited_text = "";
  let moreTextFlag = text.length > limit ? true : false;
  let charLimit = limit;
  for (let i = 0; i < array.length; i++) {
    if (i > lineLimit - 1) {
      moreTextFlag = true;
      break;
    }
    if (charLimit > 0) {
      if (array[i] === "") {
        limited_text = limited_text + "\n";
      } else if (array[i].length <= charLimit) {
        limited_text = limited_text + array[i] + "\n";
        charLimit = charLimit - array[i].length;
      } else {
        const t1 = getPureText(array[i], charLimit, userTagList);
        const trimed = trimIncompleteUserTag(t1, userTagList);
        limited_text = limited_text + trimed;
        moreTextFlag = true;
        break;
      }
    } else {
      moreTextFlag = true;
      break;
    }
  }

  return { limited_text, moreTextFlag };
}

function getLimitTextForIndiPost(text, userTagList, limit = 50, lineLimit = 3) {
  if (!text) return { text, flag: null };

  let array = text.split("\n");
  let limited_text = "";
  let moreTextFlag = text.length > limit ? true : false;
  let charLimit = limit;
  for (let i = 0; i < array.length; i++) {
    if (i > lineLimit) {
      moreTextFlag = true;
      break;
    }
    if (charLimit > 0) {
      if (array[i] === "") {
        limited_text = limited_text + "\n";
      } else if (array[i].length <= charLimit) {
        limited_text = limited_text + array[i] + "\n";
        charLimit = charLimit - array[i].length;
      } else {
        const t1 = getPureText(array[i], charLimit, userTagList);
        const trimed = trimIncompleteUserTag(t1, userTagList);
        limited_text = limited_text + trimed;
        moreTextFlag = true;
        break;
      }
    } else {
      moreTextFlag = true;
      break;
    }
  }

  if (moreTextFlag) {
    limited_text = limited_text + " ...";
  }

  return limited_text;
}

function getPureText(text, charLimit, userTagList) {
  let txt = text;
  if (userTagList) {
    userTagList.forEach((item) => {
      if (item.tagType === TAG_TYPE.USER_TAGGING)
        txt = txt.replace("@" + item.uid, item.User.name);
      else if (item.tagType === TAG_TYPE.COMMUNITY_TAGGING)
        txt = txt.replace("@" + item.communityID, item.Community.name);
    });

    if (txt.length < charLimit) return text;
    else {
      return text.slice(0, charLimit);
    }
  } else {
    return text;
  }
}

function trimIncompleteUserTag(text, userTagList) {
  let words = text.split(" ");
  let lastWord = words[words.length - 1];
  if (lastWord.includes("@")) {
    const k = lastWord.split("@");
    const lastMention = k[k.length - 1];
    let flag = false;

    if (userTagList) {
      for (let i = 0; i < userTagList.length; i++) {
        let item = userTagList[i];
        if (item.uid === lastMention || item.communityID === lastMention) {
          flag = true;
          break;
        }
      }
    }

    if (!flag) {
      k.pop();
      lastWord = k.join("@");
      words[words.length - 1] = lastWord;
      const t = words.join(" ");
      return t;
    }
  }
  return text;
}

export { getLimitText, getLimitTextForIndiPost };
